<!-- MACHINESTATE - OVERVIEW -->
<ng-container *ngIf="path == 'machineState'">
    <ng-container *ngIf="line == 'green'"> <!-- GREEN -->
        <app-visualizations-list></app-visualizations-list>
    </ng-container>

    <ng-container *ngIf="line == 'multi'"> <!-- MULTI -->
        <app-visualizations-list-multi></app-visualizations-list-multi>
    </ng-container>
</ng-container>

<!-- JOYSTICK -->
<ng-container *ngIf="path.includes('joystick')">
    <ng-container *ngIf="line == 'green'"> <!-- GREEN -->
        <app-joystick-movements></app-joystick-movements>
    </ng-container>
    <ng-container *ngIf="line == 'multi'"> <!-- MULTI -->
        <app-joystick-movements-multi></app-joystick-movements-multi>
    </ng-container>
    
</ng-container>

<!-- CURRENT -->
<ng-container *ngIf="path.includes('currents-equipment')">
    <ng-container *ngIf="line == 'green'"> <!-- GREEN -->
        <app-equipment-currents></app-equipment-currents>
    </ng-container>
    <ng-container *ngIf="line == 'multi'"> <!-- MULTI -->
        <app-equipment-currents-multi></app-equipment-currents-multi>
    </ng-container>
    
</ng-container>

<!-- PRESSURE -->
<ng-container *ngIf="path.includes('pressure-equipment')">
    <ng-container *ngIf="line == 'green'"> <!-- GREEN -->
        <app-equipment-pressures></app-equipment-pressures>
    </ng-container>
    <ng-container *ngIf="line == 'multi'"> <!-- MULTI -->
        <app-equipment-pressures-multi></app-equipment-pressures-multi>
    </ng-container>
    
</ng-container>

<!-- POSITION --> 
<!-- currently position just for greenline-->
<ng-container *ngIf="path.includes('position')"> <!-- GREEN -->
    <app-boom-stick-position></app-boom-stick-position>
</ng-container>

<!-- OPERATIONTIME -->
<ng-container *ngIf="path.includes('operation-times')">
    <ng-container *ngIf="line == 'green'"> <!-- GREEN -->
        <app-machine-components-operation-hours></app-machine-components-operation-hours>
    </ng-container>
    <ng-container *ngIf="line == 'multi'"> <!-- MULTI -->
        <app-machine-components-operation-hours-multi></app-machine-components-operation-hours-multi>
    </ng-container>
</ng-container>

<!-- CALIBRATION - MULTI ONLY -->
<ng-container *ngIf="path.includes('calibration')">
    <ng-container *ngIf="line == 'multi'"> <!-- MULTI -->
        <app-calibration-multi></app-calibration-multi>
    </ng-container>
</ng-container>

<!-- FAHRANTRIEB - MULTI ONLY -->
 <ng-container *ngIf="path.includes('drive')">
    <ng-container *ngIf="line == 'multi'"> <!-- MULTI -->
        <app-drive-multi></app-drive-multi>
    </ng-container>
</ng-container>